/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".loan-confirm-img[_ngcontent-%COMP%]{height:100px;margin-top:20px}.heading-style[_ngcontent-%COMP%]{color:#054263;font-family:lato-heavy}"];
export { styles as styles };

